import React, { createContext, useContext, useState, useRef } from "react";

const ActiveMeetingContext = createContext(null);

export function ActiveMeetingProvider({ children }) {
  const [activeMeeting, setActiveMeeting] = useState(null); // { room, token, lobbyEnabled }
  const jitsiApiRef = useRef(null);

  /**
   * Dispose the Jitsi API and clear the meeting state.
   * Called by JitsiPortal when Leave is clicked or Jitsi fires videoConferenceLeft.
   */
  const clearMeeting = () => {
    if (jitsiApiRef.current) {
      try { jitsiApiRef.current.dispose(); } catch (_) {}
      jitsiApiRef.current = null;
    }
    setActiveMeeting(null);
  };

  return (
    <ActiveMeetingContext.Provider value={{ activeMeeting, setActiveMeeting, jitsiApiRef, clearMeeting }}>
      {children}
    </ActiveMeetingContext.Provider>
  );
}

export const useActiveMeeting = () => {
  const ctx = useContext(ActiveMeetingContext);
  if (!ctx) throw new Error("useActiveMeeting must be used inside ActiveMeetingProvider");
  return ctx;
};
